export default __webpack_public_path__ + "img/1f0a3d0f46090e84c44891096b559abc.png";